<template>
  <div class="banners">
    <div class="banners__carousel glide">
      <div class="glide__track" data-glide-el="track">
        <div class="glide__slides">
          <li v-if="!banners.length"></li>
          <li v-for="banner in banners" :key="banner.id">
            <a
              v-if="banner.url"
              :href="banner.url"
              :target="banner.new_window ? '_blank' : '_self'"
            >
              <img :src="banner.image" />
            </a>
            <img v-else :src="banner.image" />
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerService from '@/services/banner.service';
import Glide from '@glidejs/glide';

export default {
  name: 'banners-carousel',
  data: () => {
    return {
      glide: null,
      banners: [],
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    load() {
      const promise = this.isAuthenticated
        ? BannerService.getByNetwork(this.$store.getters.user.network_id)
        : BannerService.getLoginBanners();

      promise
        .then(({ data: banners }) => {
          this.banners = banners;
          this.$nextTick(() => this.initGlide());
        })
        .finally(() => (this.isLoading = false));
    },
    initGlide() {
      this.glide && this.glide.destroy();
      this.glide = new Glide('.glide', {
        autoplay: this.banners.length > 1 ? 3000 : false,
        type: 'carousel',
      }).mount();
    },
  },
  watch: {
    isAuthenticated() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.banners {
  &__header {
    text-align: center;

    p {
      font-size: 1.2em;
      font-weight: 300;
      color: var(--text-color-light);
    }

    h2 {
      font-family: var(--font-family-secondary);
      font-size: 2.2em;
      font-weight: 600;
      color: var(--color-secondary);
    }
  }

  &__carousel {
    li {
      img {
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
